module.exports = __webpack_public_path__ + "static/media/lens2_big.296c5e6a.png";